/**
 * i18n entrypoint. English is always loaded synchronously (fallback for
 * every key). The other 11 languages are dynamically imported on demand,
 * so a Spanish visitor only downloads en + es chunks.
 */
import en from './locales/en';

export const SUPPORTED_LANGS = [
  'en', 'de', 'es', 'ca', 'fr', 'it', 'pt', 'pl', 'ru', 'uk', 'zh', 'ja',
];

// Dictionary of already-loaded language tables.
export const loaded = { en };

const LOADERS = {
  de: () => import(/* webpackChunkName: "i18n-de" */ './locales/de'),
  es: () => import(/* webpackChunkName: "i18n-es" */ './locales/es'),
  ca: () => import(/* webpackChunkName: "i18n-ca" */ './locales/ca'),
  fr: () => import(/* webpackChunkName: "i18n-fr" */ './locales/fr'),
  it: () => import(/* webpackChunkName: "i18n-it" */ './locales/it'),
  pt: () => import(/* webpackChunkName: "i18n-pt" */ './locales/pt'),
  pl: () => import(/* webpackChunkName: "i18n-pl" */ './locales/pl'),
  ru: () => import(/* webpackChunkName: "i18n-ru" */ './locales/ru'),
  uk: () => import(/* webpackChunkName: "i18n-uk" */ './locales/uk'),
  zh: () => import(/* webpackChunkName: "i18n-zh" */ './locales/zh'),
  ja: () => import(/* webpackChunkName: "i18n-ja" */ './locales/ja'),
};

export async function ensureLoaded(lang) {
  if (loaded[lang]) return loaded[lang];
  const loader = LOADERS[lang];
  if (!loader) return loaded.en;
  try {
    const mod = await loader();
    loaded[lang] = mod.default || mod;
  } catch (_) {
    loaded[lang] = loaded.en;
  }
  return loaded[lang];
}
